export default [
    {
        path: 'visita-domiciliar',
        component: () => import(
            '@/views/atencao-basica/visita-domiciliar/Index'
        ),
        redirect: 'visita-domiciliar/index',
        children: [
            {
                name: 'atencao-basica-visita-domiciliar',
                path: 'index',
                props: true,
                component: () => import(
                    '@/views/atencao-basica/visita-domiciliar/ListPaciente'
                ),
            },
            {
                name: 'atencao-basica-visita-domiciliar-list',
                path: 'list/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/atencao-basica/visita-domiciliar/List'
                ),
            },
            {
                name: 'atencao-basica-visita-domiciliar-create',
                path: 'create/:pacienteId',
                component: () => import(
                    '@/views/atencao-basica/visita-domiciliar/Form'
                )
            },
            {
                name: 'atencao-basica-visita-domiciliar-edit',
                path: 'edit/:pacienteId/:id',
                component: () => import(
                    '@/views/atencao-basica/visita-domiciliar/Form'
                )
            },
        ],
    },
]